import { ProductEntry, SubscriptionInfoContainer } from '../../../store/api';
import { ExtendedManageSubscriptionIndividual } from '../table/extended/ExtendedManageSubscriptionIndividual';
import { formatUsageLimit } from '../../../shared/utils/formatUsageLimit';
import {
    ExtendedManageSubscriptionTableIndividualCell,
    ManageSubscriptionTableCell
} from '../utils/subscriptionTableTileTypes';
import { mapIssueUsageIndividual } from '../../../shared/subscription-management/mappings/mapIssueUsage';
import { issueNotDeliveredYet } from '../../../shared/subscription-management/types/IssueUsage';
import i18n from '../../../../i18n';

export const mapExtendedIndividual = (
    item: ProductEntry,
    onAddCopy: (item: ProductEntry) => void,
    onExpireIssues: (item: ProductEntry) => void
): ExtendedManageSubscriptionIndividual => {
    const {
        currentSubscriptions,
        nextSubscriptions,
        previousIssueStatistics,
        currentIssueStatistics,
        expired,
        expirationDate,
        ceased
    } = item;

    return {
        currentYearSubscription: expired
            ? {
                  type: ExtendedManageSubscriptionTableIndividualCell.Expired,
                  onAddCopy: () => onAddCopy(item),
                  onExpireIssues: () => onExpireIssues(item),
                  expirationDate
              }
            : ceased
            ? {
                  type: ExtendedManageSubscriptionTableIndividualCell.Ceased,
                  onAddCopy: () => onAddCopy(item),
                  onExpireIssues: () => onExpireIssues(item),
                  expirationDate
              }
            : currentSubscriptions && currentSubscriptions.individualUsageLimit != null
            ? currentSubscriptions.individualUsageLimit > 0
                ? {
                      type: ExtendedManageSubscriptionTableIndividualCell.UsageLimitValue,
                      label: formatUsageLimit(currentSubscriptions.individualUsageLimit),
                      onAddCopy: () => onAddCopy(item),
                      stockDetails: currentSubscriptions.stockDetails.individual!
                  }
                : {
                      type: ExtendedManageSubscriptionTableIndividualCell.UsageLimitUnlimited,
                      label: formatUsageLimit(currentSubscriptions.individualUsageLimit),
                      stockDetails: currentSubscriptions.stockDetails.individual!
                  }
            : {
                  type: ExtendedManageSubscriptionTableIndividualCell.UsageLimitNone,
                  label: i18n.t('shop.subscriptions.noIndividualSubscription'),
                  onAddCopy: () => onAddCopy(item)
              },

        previousIssueUsage: hasSubscription(currentSubscriptions)
            ? previousIssueStatistics.individual
                ? mapIssueUsageIndividual(previousIssueStatistics.individual)
                : issueNotDeliveredYet
            : undefined,

        currentIssueUsage: hasSubscription(currentSubscriptions)
            ? currentIssueStatistics.individual
                ? mapIssueUsageIndividual(currentIssueStatistics.individual)
                : issueNotDeliveredYet
            : undefined,

        nextYearSubscription:
            nextSubscriptions && nextSubscriptions.individualUsageLimit != null
                ? {
                      type: ManageSubscriptionTableCell.UsageLimitValue,
                      label: formatUsageLimit(nextSubscriptions.individualUsageLimit),
                      stockDetails: nextSubscriptions.stockDetails.individual!
                  }
                : {
                      type: ManageSubscriptionTableCell.UsageLimitNone,
                      label: i18n.t('shop.subscriptions.noIndividualSubscription')
                  }
    };
};

const hasSubscription = (subscription?: SubscriptionInfoContainer) => subscription?.individualUsageLimit != null;
